import React,{useContext} from 'react';
import Context from '../store/store';
import { Switch, FormGroup, FormControlLabel, TextField} from '@material-ui/core';
import { __ } from '@wordpress/i18n';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
      margin: {
        marginBottom: '20px',
      },
});
const ThirdStep = (props) => {
    const classes = useStyles();
    const ctx = useContext(Context);
    
    return ( 
    <>
    <h3 className="mwb-title">{__( 'Setting', 'abandoned-cart-for-woocommerce' ) }</h3>
    <FormGroup>
        <FormControlLabel
            control={
            <Switch
                checked={ctx.formFields['mwb_enable_acfw']}
                onChange={ctx.changeHandler}
                name="mwb_enable_acfw"
                color="primary"
                 />
            }
            label="Enable Plugin"
            className={classes.margin} />
            <TextField 
                value={ctx.formFields['mwb_acfw_cut_off_time']}
                onChange={ctx.changeHandler} 
                id="mwb_acfw_cut_off_time" 
                name="mwb_acfw_cut_off_time" 
                helperText={__('Enter time in HOURS after which a cart will be treated as abandoned','abandoned-cart-for-woocommerce') } 
                label="Cut Off Time"  variant="outlined" className={classes.margin}/>
        </FormGroup>
    </>
    )
}
export default ThirdStep;